export default __webpack_public_path__ + "static/media/Snd_E_Starts.6d3357bc.mp3";